module.exports = __webpack_public_path__ + "img/lyyti_logo_green.8ae4c0fb.svg";